import { render } from "./WebPacks.vue?vue&type=template&id=7caa5064&scoped=true"
import script from "./WebPacks.vue?vue&type=script&lang=js"
export * from "./WebPacks.vue?vue&type=script&lang=js"

import "./WebPacks.vue?vue&type=style&index=0&id=7caa5064&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7caa5064"]])

export default __exports__